import type { CMSCampaignResponse } from './types';

/**
 * CMS contract (`referral-revamb-promotion`):
 *
 * All top-level keys are required; `priceCard` and `reviewCards` are non-empty.
 * Timer UI uses `revealEndsAt` only on reveal
 * (`screenType` 3). ISO UTC, e.g. `2026-09-16T06:30:00.000Z`.
 *
 * UI at expiry: remaining clamps to 00:00:00; timer stays visible.
 */
const resolveRevealEndsAt = (
  cms: Pick<CMSCampaignResponse, 'revealEndsAt'>
): string | undefined => {
  const endMs = new Date(cms.revealEndsAt).getTime();
  if (Number.isNaN(endMs)) return undefined;

  return new Date(endMs).toISOString();
};

export default resolveRevealEndsAt;
